<template>
  <div v-quick-title="message" class="beta-tag" :style="elStyle" @click="alertMessage">
    {{ $t('message.BETA_TAG') }}
  </div>
</template>

<script>

import { calert } from '@/utils/main';

export default {

  name: 'BetaTag',

  props: {
    color: {
      type: String,
      default: '#29a4ef', // $color-lightblue-text from vars.scss
    },
    message: {
      type: String,
      default: '',
    },
  },

  computed: {
    elStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },

  methods: {
    alertMessage() {
      if (this.message !== '') {
        calert(this.message);
      }
    },
  },
};
</script>

<style lang="scss">
.beta-tag {
  display: inline-block;
  padding: 0.1em 0.2em;
  color: white;
  font-size: 0.9em;
  font-weight: 600;
  border-radius: 0.3em;
}
</style>
